import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { useUrlRuleset } from '../../hooks/useUrlRuleset';

export function BuilderLayout() {
  // Validate and sync ruleset from URL to store
  useUrlRuleset();

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
